// extracted by mini-css-extract-plugin
export default {"CardContainer":"DashboardCardContainerWithFlow_CardContainer__cwh-U"};